import { RootState } from 'store/root-reducer';
import { GetWimGroupBindingsResponse } from './types';

export const getResult = (state: RootState): GetWimGroupBindingsResponse | null =>
  state.admin.wimGroups.getGroupsResult;

export const getGroupsLoading = (state: RootState): boolean => state.admin.wimGroups.isGetGroupsLoading;
